const CareerRoutes = {
  createCareerJob: "/createCareerJob",
  getCareerJob: "/getCareerJob",
  updateCareerJob: "/updateCareerJob",
  deleteCareerJob: "/deleteCareerJob",
  getCareerJobProposal: "/getCareerJobProposal",
};

export default CareerRoutes;
